export const TID = {
  home: {
    root: "home-dashboard",
    preset: (k) => `home-preset-${k}`,
    start: "home-range-start",
    end: "home-range-end",
    cardGaji: "home-card-gaji",
    cardKaryawan: "home-card-karyawan",
    cardHari: "home-card-hari",
    cardBarang: "home-card-barang",
    topAttendance: "home-top-attendance",
    topJarit: "home-top-jarit",
    topKasbon: "home-top-kasbon",
    topBarang: "home-top-barang",
    trend: "home-trend-chart",
    nav: (k) => `home-nav-${k}`,
    export: "home-export-btn",
    empDialog: "home-emp-dialog",
    empRow: (id) => `home-emp-row-${id}`,
  },
  login: {
    form: "login-form",
    email: "login-email-input",
    password: "login-password-input",
    submit: "login-submit-button",
    error: "login-error-message",
    forgotLink: "login-forgot-link",
    backLink: "login-back-link",
    forgotInput: "forgot-username-input",
    forgotSubmit: "forgot-submit-button",
    forgotDone: "forgot-done-message",
  },
  reset: {
    password: "reset-password-input",
    confirm: "reset-confirm-input",
    submit: "reset-submit-button",
    error: "reset-error-message",
    done: "reset-done-message",
    backLink: "reset-back-link",
  },
  account: {
    navLink: "nav-account-link",
    mobileNavLink: "nav-mobile-account-link",
    root: "account-page",
    curPassword: "account-current-password",
    newPassword: "account-new-password",
    confirmPassword: "account-confirm-password",
    changeSubmit: "account-change-submit",
    userList: "account-user-list",
    userRow: (id) => `account-user-${id}`,
    userDelete: (id) => `account-user-delete-${id}`,
    userEdit: (id) => `account-user-edit-${id}`,
    addUser: "account-add-user",
    newUsername: "account-new-username",
    newName: "account-new-name",
    newEmail: "account-new-email",
    newRole: "account-new-role",
    newUserPassword: "account-new-user-password",
    createSubmit: "account-create-submit",
  },
  chpwd: {
    trigger: "chpwd-trigger",
    mobileTrigger: "chpwd-mobile-trigger",
    dialog: "chpwd-dialog",
    newUsername: "chpwd-new-username",
    newPassword: "chpwd-new-password",
    confirmPassword: "chpwd-confirm-password",
    submit: "chpwd-submit",
  },
  nav: {
    dashboard: "nav-dashboard-link",
    employees: "nav-employees-link",
    titip: "nav-titip-link",
    jarit: "nav-jarit-link",
    logout: "nav-logout-button",
    mobileToggle: "nav-mobile-toggle",
    mobileMenu: "nav-mobile-menu",
    mobileDashboard: "nav-mobile-dashboard-link",
    mobileEmployees: "nav-mobile-employees-link",
    mobileTitip: "nav-mobile-titip-link",
    mobileJarit: "nav-mobile-jarit-link",
    mobileLogout: "nav-mobile-logout-button",
  },
  dashboard: {
    root: "dashboard-page",
    newPeriod: "new-period-button",
    createDialog: "create-period-dialog",
    bulan: "create-period-bulan-select",
    tahun: "create-period-tahun-input",
    confirm: "create-period-confirm-button",
    list: "period-list",
    search: "period-search-input",
    card: (id) => `period-card-${id}`,
    open: (id) => `period-open-${id}`,
    del: (id) => `period-delete-${id}`,
    delDialog: "period-delete-dialog",
    delConfirm: "period-delete-confirm",
    exportExcel: "dashboard-export-excel-button",
    exportDialog: "dashboard-export-dialog",
    exportStart: "dashboard-export-start-select",
    exportEnd: "dashboard-export-end-select",
    exportConfirm: "dashboard-export-confirm-button",
  },
  employees: {
    root: "employees-page",
    add: "employee-add-button",
    search: "employee-search-input",
    row: (id) => `employee-row-${id}`,
    edit: (id) => `employee-edit-${id}`,
    del: (id) => `employee-delete-${id}`,
    dialog: "employee-dialog",
    nama: "employee-nama-input",
    nik: "employee-nik-input",
    jabatan: "employee-jabatan-input",
    rate: "input-rate-per-hari",
    metode: "employee-metode-select",
    bank: "employee-bank-input",
    rekening: "employee-rekening-input",
    atasNama: "employee-atas-nama-input",
    noHp: "employee-no-hp-input",
    bpjs: "employee-bpjs-switch",
    bonus: "employee-bonus-switch",
    aktif: "employee-aktif-switch",
    save: "employee-save-button",
    delDialog: "employee-delete-dialog",
    delConfirm: "employee-delete-confirm",
  },
  payroll: {
    root: "payroll-page",
    save: "payroll-save-button",
    sync: "payroll-sync-button",
    search: "payroll-search-input",
    exportRekap: "button-export-pdf-recap",
    exportExcel: "button-export-excel",
    exportSlip: "button-export-pdf-slip",
    hari: (id) => `input-hari-kerja-${id}`,
    kasbon: (id) => `kasbon-input-${id}`,
    potonganOpen: (id) => `potongan-open-${id}`,
    pendapatanOpen: (id) => `pendapatan-open-${id}`,
    bonus: (id) => `bonus-input-${id}`,
    bpjs: (id) => `bpjs-toggle-${id}`,
    total: (id) => `total-cell-${id}`,
    slipOne: (id) => `slip-one-${id}`,
    waOne: (id) => `wa-one-${id}`,
    summaryTransfer: "subtotal-transfer-value",
    summaryTunai: "subtotal-tunai-value",
    summaryJarit: "subtotal-jarit-value",
    summaryTotal: "grand-total-value",
    jaritManage: "jarit-manage-link",
    bca: "payroll-bca-button",
    waBulk: "payroll-wa-bulk-button",
    waDialog: "payroll-wa-dialog",
    waBulkOpen: (id) => `wa-bulk-open-${id}`,
    slipDialog: "payroll-slip-dialog",
    slipSelectAll: "payroll-slip-select-all",
    slipDownload: "payroll-slip-download",
    slipRow: (id) => `slip-pick-${id}`,
  },
  bca: {
    dialog: "bca-dialog",
    date: "bca-date-input",
    download: "bca-download-button",
    errors: "bca-errors",
    summary: "bca-summary",
    rows: "bca-rows",
  },
  banks: {
    root: "banks-page",
    navLink: "nav-banks-link",
    mobileNavLink: "nav-mobile-banks-link",
    search: "banks-search-input",
    add: "banks-add-button",
    row: (id) => `bank-row-${id}`,
    edit: (id) => `bank-edit-${id}`,
    del: (id) => `bank-delete-${id}`,
    activeToggle: (id) => `bank-active-${id}`,
    dialog: "bank-dialog",
    name: "bank-name-input",
    official: "bank-official-input",
    swift: "bank-swift-input",
    biCode: "bank-bicode-input",
    transferType: "bank-transfer-type-select",
    active: "bank-active-switch",
    save: "bank-save-button",
    delDialog: "bank-delete-dialog",
    delConfirm: "bank-delete-confirm",
  },
  potongan: {
    dialog: "potongan-dialog",
    add: "button-add-potongan",
    keterangan: (i) => `input-potongan-keterangan-${i}`,
    nominal: (i) => `input-potongan-nominal-${i}`,
    remove: (i) => `button-remove-potongan-${i}`,
    preset: (name) => `potongan-preset-${name}`,
    done: "potongan-done-button",
    total: "potongan-total-value",
  },
  pendapatan: {
    dialog: "pendapatan-dialog",
    add: "button-add-pendapatan",
    keterangan: (i) => `input-pendapatan-keterangan-${i}`,
    nominal: (i) => `input-pendapatan-nominal-${i}`,
    remove: (i) => `button-remove-pendapatan-${i}`,
    preset: (name) => `pendapatan-preset-${name}`,
    done: "pendapatan-done-button",
    total: "pendapatan-total-value",
  },
  titip: {
    root: "titip-page",
    add: "titip-add-button",
    dialog: "titip-dialog",
    emp: "titip-emp-select",
    tipe: "titip-tipe-select",
    tanggal: "titip-tanggal-input",
    nominal: "titip-nominal-input",
    keterangan: "titip-keterangan-input",
    save: "titip-save-button",
    card: (id) => `titip-card-${id}`,
    detailDialog: "titip-detail-dialog",
    entryDel: (id) => `titip-entry-delete-${id}`,
    delDialog: "titip-delete-dialog",
    delConfirm: "titip-delete-confirm",
  },
  jarit: {
    root: "jarit-page",
    tailor: "jarit-tailor-select",
    bulan: "jarit-bulan-select",
    tahun: "jarit-tahun-input",
    tanggal: "jarit-tanggal-input",
    barang: "jarit-barang-input",
    jumlah: "jarit-jumlah-input",
    harga: "jarit-harga-input",
    add: "jarit-add-button",
    entryDel: (id) => `jarit-entry-delete-${id}`,
    bpjs: "jarit-bpjs-input",
    kasbon: "jarit-kasbon-input",
    bonus: "jarit-bonus-input",
    saveRecap: "jarit-recap-save-button",
    totalSisa: "jarit-total-sisa",
    openCurrent: "jarit-open-current-button",
    back: "jarit-back-button",
    exportXlsx: "jarit-export-xlsx-button",
    exportMenu: "jarit-export-menu-button",
    exportXlsxAll: "jarit-export-xlsx-all",
    exportXlsxOne: "jarit-export-xlsx-one",
    slipAll: "jarit-slip-all",
    slipOne: "jarit-slip-one",
    periodOpen: (t, b) => `jarit-period-open-${t}-${b}`,
  },
};
